import { combineReducers } from 'redux';
import authReducer from './authReducer';
import partnerReducer from './partnerReducer';

export default combineReducers({
  auth: authReducer,
  listPartner: partnerReducer
});